module.exports = __webpack_public_path__ + "img/wallet_02_bg.c5ba1eec.jpg";